import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Home, Building2, Snowflake, Wind } from 'lucide-react';
export function ServiceSelector() {
  const services = [{
    icon: Wind,
    title: 'Ducted Systems',
    desc: 'Whole-home reverse cycle. Quiet, zoned, controlled from your phone.',
    price: 'From A$10,000',
    slug: '/ducted-air-conditioning/',
    featured: true
  }, {
    icon: Home,
    title: 'Split Systems',
    desc: 'One room or multiple. Fast install, big efficiency gains.',
    price: 'From A$2,500',
    slug: '/split-systems-perth/'
  }, {
    icon: Snowflake,
    title: 'Reverse Cycle',
    desc: 'Heating and cooling combined. The Perth standard.',
    price: 'From A$2,500',
    slug: '/reverse-cycle-air-conditioning-perth/'
  }, {
    icon: Building2,
    title: 'Commercial',
    desc: 'Offices, retail, warehouses. Sized correctly the first time.',
    price: 'From A$5,000',
    slug: '/commercial-air-conditioning-installation-in-perth/'
  }];
  return <section className="bg-cream py-20 md:py-28 scroll-mt-24" data-id="element-667" data-mp="2eo2zk981q87">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-668" data-mp="2f7h0pvr3ugy">
        <div className="max-w-3xl mb-12" data-id="element-669" data-mp="6fzszqw0cdgx">
          <div className="kicker mb-3" data-id="element-670" data-mp="6ey9cy0xeinl">Where to start</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink-900 tracking-tight leading-tight" data-id="element-671" data-mp="bfm4nvw6tlnm">
            Which service do you need?
          </h2>
          <p className="mt-4 text-lg text-stone-600 max-w-2xl" data-id="element-672" data-mp="ld0al1khis1o">
            Pick the path that fits your home. Not sure? Choose any. Our team will confirm the right system at your free on-site assessment.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-673" data-mp="u4k6zh1ngpth">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <motion.a key={i} href={service.slug} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.08
          }} className={`group lift-card relative flex flex-col rounded-2xl p-7 bg-white border ${service.featured ? 'border-brand shadow-lg shadow-brand/10' : 'border-stone-200'}`} data-id="element-674" data-mp="1452x2tjt52ju" data-mpi={i}>
                {service.featured && <span className="absolute -top-2 right-5 px-2.5 h-5 inline-flex items-center bg-accent text-ink-900 text-[10px] uppercase tracking-wider font-bold rounded-full" data-id="element-675" data-mp="3sv252v0m5y22">
                    Most popular
                  </span>}
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-6 ${service.featured ? 'bg-brand text-white' : 'bg-brand-soft text-brand'}`} data-id="element-676" data-mp="1tj91ugn8fwgw">
                  <Icon size={22} strokeWidth={2} data-id="element-677" data-mp="e01gbnfe1ad5" />
                </div>
                <h3 className="font-display text-xl font-extrabold text-ink-900 tracking-tight mb-2" data-id="element-678" data-mp="3vg9ix3uic4yr">
                  {service.title}
                </h3>
                <p className="text-sm text-stone-600 leading-relaxed mb-5 flex-grow" data-id="element-679" data-mp="48dtjzts0hi0">
                  {service.desc}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-stone-200" data-id="element-680" data-mp="3reoapvsx4euw">
                  <span className="text-sm font-bold text-ink-900 tabular-nums" data-id="element-681" data-mp="3chf640eltel8">
                    {service.price}
                  </span>
                  <span className="inline-flex items-center gap-1 text-sm font-semibold text-brand group-hover:gap-2 transition-all" data-id="element-682" data-mp="3hhjlto7ou5ae">
                    Explore
                    <ArrowRight size={14} strokeWidth={2.5} data-id="element-683" data-mp="1fovgn9bhh7rz" />
                  </span>
                </div>
              </motion.a>;
        })}
        </div>
      </div>
    </section>;
}